import { defineMessages } from 'react-intl'

const scope = 'app.containers.UserProfile'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'User: {email}',
  },
  fields: {
    fullName: {
      id: `${scope}.fullName`,
      defaultMessage: 'Full Name',
    },
    organizationId: {
      id: `${scope}.organizationId`,
      defaultMessage: 'Organization',
    },
    roleId: {
      id: `${scope}.roleId`,
      defaultMessage: 'Role',
    },
  },
  actions: {
    changePassword: {
      id: `${scope}.actions.changePassword`,
      defaultMessage: 'Change Password',
    },
  },
})
